<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>


      <div class="modal fade show " id="modal-mapa" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMapa">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">
              <a class="close" data-dismiss="modal" aria-label="Fechar" style=" z-index: 1000000; font-size: 69px; color: #000; float: right; right: 0; position: absolute; top: -40px; opacity: 1;" v-on:click="showModalMapa = false">
                <span aria-hidden="true">&times;</span>
              </a>
              <gmap-map
                :center="center"
                :zoom="15"
                ref="map"
                :options="{ gestureHandling: 'greedy'}"
                style="width:calc(100vw - 28px);  height: calc(100vh - 64px)"
              >
                <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                  <span v-html="infoContent"></span>
                </gmap-info-window>
                <gmap-marker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  @click="toggleInfoWindow(m,index)"
                ></gmap-marker>
                <gmap-polyline v-if="path.length > 0" :path="path" :editable="false"
                    ref="polyline">
                </gmap-polyline>
              </gmap-map>  
              
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMapa = false">Fechar</button>
            </div> -->
          </div>
        </div>
      </div>


      <div id="relatorio" class="card">
        <div class="card-title">
          <strong></strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h3>Relatório de Telemetria - Viagem por Veiculo</h3>
            </div>
            <div class="col-md-6 text-right">
              
              
              <!-- <button class="btn btn-success" v-on:click="visualizarMapa()">Ver no Mapa</button> -->
              <router-link id="btnNovoVeiculo" class="btn btn-danger" to="/relatoriosTelemetria">
                <span class="glyphicon glyphicon-plus"></span> Fechar
              </router-link>
            </div>
          </div>

          <div class="row" style="margin-top: 12px; margin-bottom: 12px;">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-5">
                  <strong>Empresa: </strong>Fenix Sat Ltda
                </div>
              </div>
            </div>
          </div>
          

          <template v-if="processando === false">
            <template v-if="dadosRelatorios.length > 0">
              <div id="relatorioTelemetriaViagemGeral">
                <table id="tableRelatorioTelemetriaViagemGeral" class="table table-responsive-sm table-hover table-outline mb-0" style="table-layout: fixed;">
                  <thead class="thead-light">
                    <tr>
                      <th width="250">Veículo</th>
                      <th width="150">Periodo</th>
                      <th width="80">Distância</th>
                      <th width="80">Tempo</th>
                      <th width="120">T. Parado</th>
                      <th width="120">T. em Movimento	</th>                   
                      <th width="120">T. em Excesso</th>
                      <th width="80">Vel Max</th>
                      <th width="80">Vel Média</th>
                      <th width="200">Motorista</th>
                      <th width="120">Transgressões</th>
                      <th width="80">Total</th>
                      <th width="120">Média por km</th>
                      <th width="120">Classificação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dados, i) in dadosRelatorios" :class="{ 'selecionado': selecionado(dados) }" @click="selecionarItem(dados, $event)" >
                      <td>
                        <input :id="'latitudeI_'+i" type="hidden" v-model="dados.latitudeInicio" />
                        <input :id="'longitudeI_'+i" type="hidden" v-model="dados.longitudeInicio" />
                        <input :id="'latitudeF_'+i" type="hidden" v-model="dados.latitudeFim" />
                        <input :id="'longitudeF_'+i" type="hidden" v-model="dados.longitudeFim" />
                        <small class="text-muted">{{dados.veiculoDescricao}}</small>
                      </td>
                      <td>
                        <small class="text-muted">{{dados.dataInicial}}</small><br>
                        <small class="text-muted">{{dados.dataFinal}}</small>
                      </td>
                      <td><small class="text-muted">{{dados.viagemDistancia}}</small></td>
                      <td><small class="text-muted">{{dados.viagemTempo}}</small></td>
                      <td>
                        <small class="text-muted">{{dados.tempoParado}}</small>
                        <small class="text-danger">{{dados.tempoParadoPercentual}} %</small>
                      </td>
                      <td>
                        <small class="text-muted">{{dados.tempoMovimento}}</small>
                        <small class="text-danger">{{dados.tempoMovimentoPercentual}} %</small>
                      </td>
                      <td>
                        <small class="text-muted">{{dados.tempoExcessoVelocidade}}</small>
                        <small class="text-danger">{{dados.tempoExcessoVelocidadePercentual}} %</small> 
                      </td>
                      <td><small class="text-muted">{{dados.velocidadeMaxima}}</small></td>
                      <td><small class="text-muted">{{dados.velocidadeMedia}}</small></td>
                      
                      <td><template v-if="dados.motoristaNome !== ''"><small class="text-muted">{{dados.motoristaNome}}</small></template></td>
                      <td>
                        <span v-tooltip="'Excesso de Velocidade'"><small class="text-muted">{{dados.alertaExcessoVelocidade}}</small> / </span>
                        <span v-tooltip="'Excesso Velocidade na Chuva'"><small class="text-muted">{{dados.alertaExcessoVelocidadeChuva}}</small> / </span>
                        <span v-tooltip="'Excesso de Velocidade dentro de cerca'"><small class="text-muted">{{dados.alertaExcessoVelocidadeCerca}}</small> / </span>
                        <span v-tooltip="'Aceleração Brusca'"><small class="text-muted">{{dados.alertaAceleracaoBrusca}}</small> / </span>
                        <span v-tooltip="'Freada Brusca'"><small class="text-muted">{{dados.alertaFreadaBrusca}}</small> / </span> 
                        <span v-tooltip="'Mudança Faixa Brusca'"><small class="text-muted">{{dados.alertaMudancaFaixaBrusca}}</small> </span>
                      </td>
                      <td><span v-tooltip="'Total de Transgressões'"><small class="text-muted">{{dados.alertaTotalTransgressoes}}</small></span></td>
                      <td><small class="text-muted">{{dados.alertaMediaPorKm}}</small></td>
                      <td><small class="text-muted">{{dados.alertaClassificacao}}</small></td>
                    </tr>
                  </tbody>
                  
                </table>
              </div>
            </template>          
            <template v-else>
              <div id="relatorio-sem-dados">
                <h1><bold>Sem dados para o período</bold></h1>
              </div>
            </template>
          </template>
        </div>
      </div> 
    </div>                               
  </div>
</template>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCNdW9zNp4aaHrlBIX8r7YnB3Axv4kvDv0"></script>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    }
  },
  mounted () {
    this.buscarRelatorio()
  },
  methods: {
    selecionarItem: function (item, event) {
      this.selecionada = item.id
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados.push(item)
        }
      } else {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados = []
          this.selecionados.push(item)
        }
      }
      this.selecionados = this.selecionados.sort((a, b) => b.id - a.id)
    },
    selecionado: function (item) {
      return this.selecionados.includes(item)
    },
    buscarRelatorio: function () {
      var self = this
      self.processando = true
      var veiculoId = this.$route.params.veiculoId
      var dataHoraInicial = this.$route.params.dataHoraInicial
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/')
      var dataHoraFinal = this.$route.params.dataHoraFinal
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/')
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/relatoriosTelemetria/viagemPorVeiculo?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosRelatorios = dadosCadastro
        self.processando = false
        self.markers = []
        self.path = []
        self.removerMarkers()
      })
    },
    async visualizarMapa () {
      let self = this
      self.removerMarkers()
      self.showModalMapa = true
      await new Promise(resolve => setTimeout(resolve, 2000))
      self.adicionarMarkers()
    },
    adicionarMarkers () {
      let self = this
      self.removerMarkers()
      let bounds = null
      let myLatLng = null
      if (self.selecionados.length > 0) {
        for (let i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            let marker = {}
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              }
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo })
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            })
            // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
            self.center = marker
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds()
            }
            bounds.extend(myLatLng)
            // this.$refs.map.fitBounds(bounds)
            // self.$refs.map.fitBounds(bounds)
          }
        }
      } else {
        for (let i = 0; i < self.dadosRelatorios.dados.length; i++) {
          console.log(self.dadosRelatorios.dados[i].latitude)
          if (self.dadosRelatorios.dados[i].latitude !== 0) {
            let marker = {}
            if (self.dadosRelatorios.dados[i].latitude !== '0') {
              marker = {
                lat: self.dadosRelatorios.dados[i].latitude,
                lng: self.dadosRelatorios.dados[i].longitude
              }
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[i].hora, ignicao: self.dadosRelatorios.dados[i].ignicao, velocidade: self.dadosRelatorios.dados[i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[i].pontoMaisProximo })
            self.path.push({
              lat: self.dadosRelatorios.dados[i].latitude,
              lng: self.dadosRelatorios.dados[i].longitude
            })
            // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
            self.center = marker
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds()
            }
            bounds.extend(myLatLng)
            // self.$refs.map.fitBounds(bounds)
            // self.selecionados.push(self.dadosGrid[i].idVeiculo)
          }
        }
      }
      self.$nextTick(() => {
        console.log(bounds)
        self.setMapBounds()
        // self.$refs.map.$mapCreated.then(() => {
        //   self.$refs.map.$mapObject.fitBounds(bounds)
        // })
      })
      // this.$refs.map.$mapPromise.then(() => {
      //   console.log(bounds)
      //   this.$refs.map.$mapObject.fitBounds(bounds)
      // })
      // self.center = marker
      self.currentPlace = null
      // self.$refs.map.fitBounds(self.markers)
      // })
    },
    removerMarkers () {
      let self = this
      self.markers = []
      self.path = []
    },
    setMapBounds () {
      let self = this
      var bounds = new window.google.maps.LatLngBounds()
      for (let i = 0; i < this.markers.length; i++) {
        let myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng })
        bounds.extend(myLatLng)
      }
      // this.markers.forEach(marker => {
      //   bounds.extend(new window.google.maps.LatLng(marker.position.lat, marker.position.lng))
      // })
      setTimeout(function () {
        self.$refs.map.fitBounds(bounds)
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18)
        }
      }, 500)
      // console.log(self.$refs.map.getZoom())
      console.log(self.$refs.map.$mapObject.zoom)
      console.log(self.$refs.map.zoom)
      // this.$refs.map.$mapCreated.then((map) => {
      //   map.fitBounds(bounds)
      // })
      // Vue.$gmapDefaultResizeBus.$emit("resize")
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>'
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/relatoriosTelemetria/RelatorioTelemetriaViagemPorVeiculoView.vue